import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class UserResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            'object': {
                'delivery_site_user_roles': [{
                    'delivery_site': {
                        'address': 'PANAMERICANA KM 37,500',
                        'city': 'GARIN',
                        'code': '00',
                        'customer': {
                            'business_name': 'BREAD FACTORY SA',
                            'code': '000725',
                            'fantasy_name': 'BOULAN',
                            'taxpayer_identification_number': '30713810203'
                        },
                        'name': 'OFICINA CENTRAL'
                    },
                    'role': 'FRONTOFFICE_ORDERS_ADMIN'
                }, {
                    'delivery_site': {
                        'address': 'PANAMERICANA KM 37,500',
                        'city': 'GARIN',
                        'code': '00',
                        'customer': {
                            'business_name': 'BREAD FACTORY SA',
                            'code': '000725',
                            'fantasy_name': 'BOULAN',
                            'taxpayer_identification_number': '30713810203'
                        },
                        'name': 'OFICINA CENTRAL'
                    },
                    'role': 'FRONTOFFICE_ORDERS_ADMIN'
                }],
                'user': {'email': 'lcuadrado@eryx.co'},
                'permissions': [
                        'USERS_PERMISSION',
                        'CURRENT_ACCOUNT_PERMISSION',
                ],
                'customer_groups': [
                    {
                        'code': '01',
                        'name': 'CLIENTES GRANDES',
                        'customers':[
                            {'customer': {
                                    'business_name': 'BREAD FACTORY SA',
                                    'code': '000725',
                                    'fantasy_name': 'BOULAN',
                                    'taxpayer_identification_number': '30713810203'
                                }
                            }
                        ],
                    }
                ]
            },
            'errors': [],
        }
    }

    deliverySiteUserRoles() {
        return this.content().delivery_site_user_roles.map(deliverySiteUserRole => {
            return {
                'deliverySite': {
                    'address': deliverySiteUserRole.delivery_site.location.address,
                    'city': deliverySiteUserRole.delivery_site.location.city,
                    'code': deliverySiteUserRole.delivery_site.code,
                    'customer': {
                        'businessName': deliverySiteUserRole.delivery_site.customer.business_name,
                        'code': deliverySiteUserRole.delivery_site.customer.code,
                        'fantasyName': deliverySiteUserRole.delivery_site.customer.fantasy_name,
                        'taxpayerIdentificationNumber': deliverySiteUserRole.delivery_site.customer.taxpayer_identification_number
                    },
                    'name': deliverySiteUserRole.delivery_site.name
                },
                'role': deliverySiteUserRole.role
            }
        });
    }

    roles() {
        return this.content().delivery_site_user_roles.map(deliverySiteUserRole => {
            return deliverySiteUserRole.role
        });
    }

    permissions() {
        return this.content().permissions.map(permission => {
            return permission
        });
    }

    customersGroups() {
        const customerGroups = this.content().customer_groups
        return customerGroups.map(customer_group => {
            return {
                name: customer_group.name,
                code: customer_group.code,
                customers: this._customersAdapter(customer_group.customers)
            }
        })
    }

    _customersAdapter(customers) {
        return customers.map(customer => {
            return {
                code: customer.code,
                fantasyName: customer.fantasy_name,
                businessName: customer.business_name,
                taxpayerIdentificationNumber: customer.taxpayer_identification_number
            };
        });
    }

}